import type { FC } from "react";

import { Counter as CounterUi } from "@jti/ui/components/Counter/Counter";

import { ResponsiveBackgroundImage } from "../HeroBannerContainer/ResponsiveBackgroundImage";

import type { counterInputs } from "./Counter.builder";

type CounterBuilderProps = BuilderComponentProps<typeof counterInputs>;

export const Counter: FC<CounterBuilderProps> = (props) => {
  return (
    <CounterUi
      date={props.date}
      title={props.title}
      description={props.description}
      desktopBackgroundImage={props.desktopBackgroundImage}
      tabletBackgroundImage={props.tabletBackgroundImage}
      mobileBackgroundImage={props.mobileBackgroundImage}
      renderBackgroundImage={() => (
        <ResponsiveBackgroundImage
          desktopImage={props.desktopBackgroundImage}
          mediumImage={props.tabletBackgroundImage}
          smallImage={props.mobileBackgroundImage}
          index={0}
        />
      )}
    />
  );
};
